import { Component, computed, input } from '@angular/core';
import { NumberFormatOptions, NumberPipe } from '@progress/kendo-angular-intl';
import {
  PopoverAnchorDirective,
  PopoverBodyTemplateDirective,
  PopoverComponent,
} from '@progress/kendo-angular-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '../../pipes';

@Component({
  selector: 'rc-value-mismatch',
  imports: [
    PopoverAnchorDirective,
    PopoverComponent,
    NumberPipe,
    TranslateModule,
    CapitalizePipe,
    PopoverBodyTemplateDirective,
  ],
  templateUrl: './value-mismatch.component.html',
})
export class ValueMismatchComponent {
  value = input<number | null | undefined>(undefined);
  calculatedValue = input<number | null | undefined>(undefined);
  label = input('VALUE');
  calculatedLabel = input('CALCULATED_VALUE');

  /** The difference of the amounts, or null while one of them is missing. */
  difference = computed(() => {
    const val = this.value();
    const calc = this.calculatedValue();
    return val != null && calc != null ? Math.abs(val - calc) : null;
  });

  /**
   * Only differences of more than one cent warn; up to one cent is rounding. The epsilon keeps floating point noise
   * from deciding a one-cent difference: 10.01 - 10 is 0.00999…, 1.02 - 1.01 is 0.0100…01; neither warns.
   */
  hasMismatch = computed(() => {
    const difference = this.difference();
    return difference != null && difference > 0.01 + 1e-9;
  });

  decimalFormat: NumberFormatOptions = {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: true,
  };
}
